import { selectLoading } from "modules/notification";
import { getProductCategoryDetailData } from "modules/reporting/redux";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductCategoryDetailPanel from './productCategoryDetailPanel.component';

export default function ProductCategoryDetailPanelContainer({
    urlProductCategoryDetail,
    currentFilter,
    translate
}){
    const dispatch = useDispatch();

    // (1) get product category detail data -- start
    const isFetchingProductCategoryDetailData = useSelector(state => selectLoading(state, getProductCategoryDetailData.typePrefix));
    const productCategoryDetailData = useSelector(state => state.reporting.product.productCategoryDetailData);
    // (1) get product category detail data -- end

    useEffect(() => {
        dispatch(getProductCategoryDetailData({
            category_uuid: currentFilter.categoryUuid,
            branch_uuid: currentFilter.branchUuid,
            period: currentFilter.period,
            start_date: moment(currentFilter.dateRange[0]).format('YYYY-MM-DD'),
            end_date: moment(currentFilter.dateRange[1]).format('YYYY-MM-DD'),
            url: urlProductCategoryDetail
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentFilter, dispatch])

    return (
        <ProductCategoryDetailPanel
            status={{
                isFetchingProductCategoryDetailData
            }}

            data={{
                productCategoryDetailData
            }}

            currentFilter={currentFilter}

            translate={translate}
        />
    )
}